enum IntegrationModuleEnum  {
  Zapier = 1,
  EventBright = 2,
  Lyyti = 3,
}
export default Object.freeze(IntegrationModuleEnum);

